import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Form, Input, notification, Row, Col, Button, Breadcrumb, Typography, Spin, Select, DatePicker } from 'antd';
import {
  backButton,
  formItemLayout,
  tailFormItemLayout,
  unexpectedError,
  parseDate,
  formatDate,
  onlyNumber,
} from '../../../common_functions';
import { PAPER_SHEEN, OBA, PAPER_WEIGHT, PAPER_TEXTURE } from '../../../config';
const PaperGroupForm = props => {
  const { section, id } = useParams();
  const [paperGroup, setPaperGroup] = useState({});
  const [familyData, setFamilyData] = useState([]);
  const [loading, setLoading] = useState(false);
  const formRef = useRef(null);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      try {
        await getPaperFamily();
        if (id !== 'new') {
          const { data } = await props.getItem('paper_groups', id);
          data.paper_manufacturer_date = parseDate(data.paper_manufacturer_date);
          setPaperGroup(data);
          formRef.current.setFieldsValue(data);
        }
      } catch (error) {
        unexpectedError(error);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [section, id]);

  let onFinish = async values => {
    setLoading(true);
    values.paper_manufacturer_date = formatDate(values.paper_manufacturer_date);
    let newState = {
      ...paperGroup,
      ...values,
    };
    try {
      let { data } = await props.saveItem('paper_groups', newState);
      if (data) {
        notification['success']({
          message: 'Paper Group saved successfully!',
          duration: 2,
        });
        backButton(props, `/settings/paper-groups`);
      }
    } catch (error) {
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };
  let onFinishFailed = ({ errorFields }) => {
    formRef.current.scrollToField(errorFields[0].name);
  };

  const getPaperFamily = async () => {
    const { data: family } = await props.getItems('paper_family', {
      fields: ['id,name'],
      sort: 'name',
      limit: '-1',
    });
    setFamilyData(family);
  };

  return (
    <Spin spinning={loading} size="large">
      <Row>
        <Col className="app-breadcrumb-col">
          <Breadcrumb separator="/" items={[{ title: "Settings", href: "/settings/paper-groups" }, { title: "Paper Groups", href: "/settings/paper-groups" }, { title: id !== 'new' ? `Edit Paper Group` : 'Add Paper Group' }]} />
        </Col>
        <Col className="white-paper">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                {id !== 'new' ? `Edit Paper Group: ${id}` : 'Add Paper Group'}
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end"></Col>
          </Row>
          <hr />
          <div className="artist">
            <Form
              ref={formRef}
              layout="vertical"
              {...formItemLayout}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              initialValues={{ layout: tailFormItemLayout }}
            >
              <Row gutter={24}>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="paper_family"
                    label="Paper Family"
                    rules={[
                      {
                        required: true,
                        message: 'Paper family is required!',
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select Paper Family"
                      showSearch
                      allowClear
                      optionFilterProp="children"
                      filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                    >
                      {familyData.map(item => {
                        return (
                          <Select.Option key={item.id} value={item.id}>
                            {item.name}
                          </Select.Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="name"
                    label="Name"
                    rules={[
                      {
                        required: true,
                        message: 'Name is required!',
                      },
                    ]}
                  >
                    <Input placeholder="Enter Paper Name" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="code"
                    label="Code"
                    rules={[
                      {
                        required: true,
                        message: 'Code is required!',
                      },
                    ]}
                  >
                    <Input placeholder="Enter Code" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="optical_brightener"
                    label="Optical Brightener"
                    rules={[
                      {
                        required: true,
                        message: 'Optical Brightener is required!',
                      },
                    ]}
                  >
                    {/* <Input placeholder="Enter Optical Brightener" /> */}
                    <Select
                      showSearch
                      allowClear
                      placeholder="Select Optical Brightener"
                      optionFilterProp="children"
                      filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                    >
                      {/* <Select.Option key="" value="">All</Select.Option> */}
                      {OBA.map(col => {
                        return <Select.Option key={col.key} value={col.key}>{col.value}</Select.Option>;
                      })}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item name="ba_absolute_low" label="Ba absolute Low" rules={[{ validator: onlyNumber }]}>
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item name="ba_absolute_high" label="Ba absolute High" rules={[{ validator: onlyNumber }]}>
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item name="sr_absolute_low" label="Sr absolute Low" rules={[{ validator: onlyNumber }]}>
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item name="sr_absolute_high" label="Sr absolute high" rules={[{ validator: onlyNumber }]}>
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="ba_sr_ratio_average"
                    label="Ba/Sr ratio average"
                    rules={[
                      {
                        required: true,
                        message: 'Ba/Sr ratio average is required!',
                      },
                      { validator: onlyNumber },
                    ]}
                  >
                    <Input placeholder="Enter Ba/Sr ratio average" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="ba_sr_ratio_low_limit"
                    label="Ba/Sr Ratio Low Limit"
                    rules={[
                      {
                        required: true,
                        message: 'Ba/Sr ratio low limit is required!',
                      },
                      { validator: onlyNumber },
                    ]}
                  >
                    <Input placeholder="Enter Ba/Sr ratio low limit" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="ba_sr_ratio_high_limit"
                    label="Ba/Sr Ratio High Limit"
                    rules={[
                      {
                        required: true,
                        message: 'Ba/Sr ratio high limit is required!',
                      },
                      { validator: onlyNumber },
                    ]}
                  >
                    <Input placeholder="Enter Ba/Sr ratio high limit" />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="paper_sheen"
                    label="Paper Sheen"
                    rules={[
                      {
                        required: true,
                        message: 'Paper Sheen is required!',
                      },
                    ]}
                  >
                    {/* <Input placeholder="Enter Paper Sheen" /> */}
                    <Select
                      showSearch
                      allowClear
                      placeholder="Select Paper Sheen"
                      optionFilterProp="children"
                      filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                    >
                      {PAPER_SHEEN.map(col => {
                        return <Select.Option key={col.key} value={col.key}>{col.value}</Select.Option>;
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="paper_weight"
                    label="Paper Weight"
                    rules={[
                      {
                        required: true,
                        message: 'Paper Weight is required!',
                      },
                    ]}
                  >
                    {/* <Input placeholder="Enter Paper Weight" /> */}
                    <Select
                      showSearch
                      allowClear
                      placeholder="Select Paper Weight"
                      optionFilterProp="children"
                      filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                    >
                      {PAPER_WEIGHT.map(col => {
                        return <Select.Option key={col.key} value={col.key}>{col.value}</Select.Option>;
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item name="paper_texture" label="Paper Texture">
                    {/* <Input placeholder="Enter Paper Texture" /> */}
                    <Select
                      showSearch
                      allowClear
                      placeholder="Select Paper Texture"
                      optionFilterProp="children"
                      filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                    >
                      {PAPER_TEXTURE.map(col => {
                        return <Select.Option key={col.key} value={col.key}>{col.value}</Select.Option>;
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item name="paper_type" label="Paper Type">
                    <Input placeholder="Enter Paper Type" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item name="paper_manufacturer_name" label="Paper Manufacturer Name">
                    <Input placeholder="Enter Paper Manufacturer Name" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item name="paper_manufacturer_model" label="Paper Manufacturer Model">
                    <Input placeholder="Enter Paper Manufacturer Model" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item name="paper_manufacturer_date" label="Paper Manufacturer Date">
                    <DatePicker picker="year" placeholder="Enter Paper Manufacturer Date" />
                  </Form.Item>
                </Col>

                {/* <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="characteristics_identified"
                    label="Characteristics identified above"
                    rules={[
                      {
                        required: false,
                        message: 'Characteristics identified above is required!',
                      },
                    ]}
                  >
                    <Input placeholder="Enter Characteristics identified above" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="average_print_date"
                    label="Average print date with deviation"
                    rules={[
                      {
                        required: false,
                        message: 'Average print date is required!',
                      },
                    ]}
                  >
                    <Input placeholder="Enter average print date" />
                  </Form.Item>
                </Col> */}
              </Row>

              <Form.Item {...tailFormItemLayout}>
                <Button
                  type="default"
                  htmlType="button"
                  onClick={() => backButton(props, '/settings/paper-groups')}
                  style={{
                    borderColor: '#d9d9d9',
                    background: '#f5f5f5',
                    color: 'rgba(0, 0, 0, 0.85)',
                  }}
                >
                  Back
                </Button>
                {props.showButton(props.roleType, props.tabs_permissions.settings_paper_groups, paperGroup?.id ?? '')}
              </Form.Item>
            </Form>
          </div>
        </Col>
      </Row>
    </Spin>
  );
};

export default PaperGroupForm;
